<!--
 * @Description: 特价精选酒店卡片，用于首页
 * @Date: 2019-09-26 14:50:56
 * @LastEditTime: 2019-10-12 16:51:28
 -->
<template>
    <li class="top-deals-hotel" v-if="city_code">
        <!-- 酒店图片 -->
        <div class="hotel-img" v-lazy:background-image="cover_img">
            <span class="hotel-img-tag">{{$t('save_safe')}} {{discount}}</span>
        </div>

        <!-- 酒店介绍 -->
        <div class="hotel-content">
            <p class="line-text hotel-name">{{hotel_name}}</p>
            <e-star :level="star ? star * 1 : 1" />

            <div v-if="reviews && reviews.rate" class="rate-line">
                <span class="rate-tag">{{reviews && (reviews.rate * 2).toFixed(1) || ''}}</span>
                <span class="rate-text">{{rateText}}</span>
                <span
                    class="rate-views"
                >({{reviews && reviews.reviewCount || ''}} {{$t('reviews')}})</span>
            </div>

            <hotel-tag v-for="(item, index) in label" :key="index" :type="index % 4" :text="item" />
            <div class="location-p">
                <i class="iconfont icon-location1"></i>
                {{fromCenter}}
            </div>

            <p class="hotel-price">
                <span>From</span>
                <span class="origin-price">{{unit}}{{getPrice(original_price)}}</span>
                <span class="sale-price">{{unit}} {{getPrice(sales_price)}}</span>
            </p>
        </div>
    </li>

    <li v-else class="top-deals-hotel" style="height:0;"></li>
</template>

<script>
import EStar from "@/components/Star.vue";
import HotelTag from "@/components/Tag.vue";
import { getDistance, getAmount } from "@/lib/utils";
import { mapGetters } from "vuex";

export default {
    props: [
        "cover_img",
        "discount",
        "hotel_name",
        "city_code",
        "star",
        "label",
        "address",
        "latitude",
        "longitude",
        "cityGis",
        "original_price",
        "sales_price",
        "currency",
        "reviews"
    ],
    components: {
        EStar,
        HotelTag
    },
    computed: {
        ...mapGetters(["unit", "hotel"]),
        //与市中心的距离
        fromCenter() {
            let distance = getDistance(
                this.cityGis[0],
                this.cityGis[1],
                this.latitude,
                this.longitude
            );
            return `${this.address}, ${distance.toFixed(1)}km from center`;
        },

        //Excellent （8.0-10.0）、Very good （6.0-7.9）、Average （4.0-5.9）、 Poor （2.0-3.9）、Terrible（0-1.9）
        //获取 hb 接口接口 rate *2 进行展示
        rateText() {
            if (!this.reviews) {
                return "";
            }
            let rate = this.reviews.rate * 2;
            if (rate >= 8 && rate <= 10) {
                return this.$t("excellent");
            } else if (rate < 8 && rate >= 6) {
                return this.$t("very_good");
            } else if (rate < 6 && rate >= 4) {
                return this.$t("average");
            } else if (rate < 4 && rate >= 2) {
                return this.$t("poor");
            } else {
                return this.$t("terrible");
            }
        }
    },
    methods: {
        getPrice(price) {
            return getAmount(price, this.hotel);
        }
    }
};
</script>

<style lang="scss" scoped>
.top-deals-hotel {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 270px;
    height: 370px;
    background-color: #fff;
    margin-bottom: 20px;
    transition: all ease-in-out 0.3s;
    cursor: pointer;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 26px 40px -24px rgba(0, 36, 100, 0.3);
    }

    .hotel-content {
        position: relative;
        box-sizing: border-box;
        padding: 10px;
        flex: 1;

        .rate-line {
            display: flex;
            align-items: center;
            margin: 8px 0;
        }

        .rate-tag {
            display: inline-block;
            padding: 0 5px;
            border-radius: 5px;
            background-color: #49beb7;
            color: #fff;
            font-size: 16px;
            line-height: 20px;
            margin-right: 5px;
        }
        .rate-text {
            font-size: 14px;
            color: #49beb7;
            margin-right: 5px;
        }
        .rate-views {
            font-size: 12px;
            color: #767676;
            margin-right: 5px;
        }

        .hotel-price {
            position: absolute;
            bottom: 10px;
            right: 10px;
            color: #767676;
            font-size: 14px;

            .origin-price {
                color: #c5c5c5;
                text-decoration: line-through;
                font-size: 12px;
            }

            .sale-price {
                color: #e05857;
            }
        }

        .hotel-name {
            font-size: 18px;
            line-height: 22px;
        }

        .location-p {
            margin: 8px 0;
            font-size: 12px;
            color: #767676;
            .iconfont {
                font-size: 16px;
            }
        }
    }

    .hotel-img {
        position: relative;
        width: 100%;
        height: 180px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;

        .hotel-img-tag {
            position: absolute;
            top: 10px;
            left: 10px;
            font-size: 14px;
            line-height: 28px;
            padding: 0 6px;
            color: #fff;
            background: #f96956;
            border-radius: 5px;
        }
    }

    .line-text {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/TopDealsHotel.vue